import FinancialInfo from "../financial_info/FinancialInfo";
import Header from "../../header/Header";
import Footer from "../../footer/Footer";

function FinancialLanding() {
    return (
        <div className="personal_landing">
            <Header/>
            <FinancialInfo/>
            <Footer/>
        </div>
    )
}

export default FinancialLanding